import { Dialog } from "primereact/dialog";
import { JVInput } from "../../shared/JVInput";
import { Button } from "primereact/button";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useForm } from "react-hook-form";
import { INewPage } from "./Table";
import { Fetch } from "../../shared/Fetch";
import { useEffect, useState } from "react";
import { JVCheckbox } from "../../shared/JVCheckbox";
import { JVDropdown } from "../../shared/JVDropdown";

interface IProps {
    singleData: INewPage,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reloadData: () => void
}

const schema = yup.object({
    name: yup.string().required(" Name is required"),
});

export const Form = (props: IProps) => {
    const [saveDis, setSaveDis] = useState(false);
    const [pagesDrop, setPagesDrop] = useState<Array<any>>([]);

    const { control, handleSubmit, watch, formState: { errors }, reset } = useForm<INewPage>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });
    const isFeature = watch("isFeature");

    const onSubmit = (data: INewPage) => {
        setSaveDis(true);
        saveToDB(data);
    }

    const saveToDB = async (data: any) => {
        const method = props.singleData.pageId != null ? "PUT" : "POST";
        const message = props.singleData.pageId != null ? "Updated Successfully" : "Added Successfully";

        const response = await Fetch("NewPermissionMaster", method, data, null, props.toast);
        if (response) {
            props.hideDialog();
            props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
            props.reloadData();
            loadParentPages();
            setSaveDis(false);
        } else {
            setSaveDis(false);
        }
    }

    const onHide = () => {
        props.hideDialog();
    }

    const loadParentPages = async () => {
        const response = await Fetch("Dropdown/parentPages", "GET", null, null, null);
        if (response) {
            const data: Array<any> = await response.json();
            setPagesDrop(data);
        }
    }

    useEffect(() => {
        reset(props.singleData);
    }, [props.open]);

    useEffect(() => {
        loadParentPages();
    }, []);

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Page or Feature" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput required label="Name" disabled={(props.singleData.pageId !== undefined && props.singleData.pageId > 0) ? true : false} control={control} name="name" />
                <JVInput label="Label" control={control} name="lable" />
                <JVInput label="Url" disabled={(props.singleData.pageId !== undefined && props.singleData.pageId > 0) ? true : false} control={control} name="url" />
                <JVInput label="Description" control={control} name="description" />
                <JVCheckbox control={control} disabled={(props.singleData.pageId !== undefined && props.singleData.pageId > 0) ? true : false} name="isFeature" label="Is Feature" />
                {isFeature && <JVDropdown disabled={(props.singleData.pageId !== undefined && props.singleData.pageId > 0) ? true : false} label="Parent Page" required control={control} name="parentId" options={pagesDrop} optionLabel="name" optionValue="pageId" placeholder="Select " />}

                <div className="col-12 md:col-12 flex gap-4">
                    <Button className="field col md:col" label="SAVE" type="submit" disabled={saveDis}></Button>
                    <Button className="field col md:col p-button-outlined" label="CLOSE" onClick={onHide} type="button"></Button>
                </div>
            </form>
        </Dialog>
    );
}